function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
/**
 * Taking required selectors for futher passing as props
 *
 * @param  {Object|Function} [options = {}] - options
 * @param  {Object} selectors - application selectors
 * @return {Object} - taken selectors
 */


function mapSelectedSelectorsToProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var selectors = arguments.length > 1 ? arguments[1] : undefined;
  return function (state, props) {
    var selectorsProps = typeof options === 'function' ? options(props, state) : options;
    var map = Object.keys(selectorsProps).reduce(function (localState, name) {
      var _selectorsProps$name = _slicedToArray(selectorsProps[name], 2),
          key = _selectorsProps$name[0],
          path = _selectorsProps$name[1];

      var selectorScope = selectors[key];

      if (selectorScope === undefined) {
        throw new Error("Unable to find selectors for '".concat(name, "' by scope '").concat(key, "'"));
      }

      if (path === undefined) {
        throw new Error("You have to provide a name of the selector besides the feature name (".concat(key, ")"));
      }

      var selector = selectorScope[path];

      if (selector === undefined) {
        throw new Error("Unable to find selector for '".concat(name, "' by '").concat(key, ".").concat(path, "'"));
      }

      return _objectSpread({}, localState, _defineProperty({}, name, selector(state)));
    }, {});
    return map;
  };
}

export default mapSelectedSelectorsToProps;